
import React, { useState } from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../Auth/AuthContext";
// import "../../css/admin.module.css";
import "../../css/admin.css";
const stXam = {
  color: `red`,
  textAlign: `center`,
  display: `flex`,
  justifyContent: `center`,
  fontWeight:`700`
}
const AdminPanel = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const menuItems = [
    { title: "پیشخوان", href: "/admin", icon: 'fa fa-th' },
    { title: "داشبورد اعضا", href: "/dashboard", icon: 'fa fa-home' },
    { title: "مدیریت اعضا", href: "/admin/users", icon: 'fa fa-users' },
    { title: "مدیریت دوره ها", href: "/admin/courses", icon: 'fa fa-book' },
    { title: "مدیریت سفارشات", href: "/admin/orders", icon: 'fa fa-shopping-cart' },
    { title: "مدیریت مشاوره", href: "/admin/consultations", icon: 'fa fa-headset' },
    { title: "مدیریت وبلاگ", href: "/admin/blog", icon: 'fa fa-newspaper' },
    { title: "مدیریت نظرات", href: "/admin/comments", icon: 'fa fa-comments' },
    { title: "تنظیمات سایت", href: "/admin/settings", icon: 'fa fa-cogs' },
    { title: "مدیریت لاگ ها", href: "/admin/logs", icon: 'fa fa-file-alt' },
  ]

  return (
    <>
      {/* دکمه همبرگری */}
      <button className="hamburger" onClick={toggleMenu}>
        <i className="fa fa-bars"></i>
      </button>

      {/* نوار ابزار بالای صفحه */}
      {/* نوار ابزار بالای صفحه */}


      {/* ساختار پنل مدیریت */}
      <div className={`admin-panel ${menuOpen ? "toggled" : ""}`}>
        {/* منوی کناری */}
        <aside className={`admin-menu ${menuOpen ? "active" : ""}`}>
          <span style={stXam}>خوش آمدید، {user ? user.username : "کاربر"}</span>
          <nav>
            <ul>
              {menuItems.map((item, index) => (
                <li key={index} onClick={toggleMenu}>
                  <Link to={item.href}>
                    <i className={item.icon}></i>
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div style={stXam}>
            <span style={stXam}>خروج</span>
            <button
              onClick={handleLogout}
              className="logout-btn"
              title="خروج از حساب کاربری"
            >
              <i className="fa fa-power-off"></i>
            </button>
          </div>
        </aside>

        {/* محتوای اصلی */}
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default AdminPanel;
